import { useSSRData } from 'hooks';
import { getBaseUrls } from 'utils';
import getFirstCorrectData from './utils';

const useBaseUrls = () => {
    const state = useSSRData();
    return getFirstCorrectData(
        // eslint-disable-next-line camelcase
        state?.base_urls,
        getBaseUrls(),
        {},
    );
};

export default useBaseUrls;
